import type { ReactNode } from 'react';
import { useGithubSignedIn } from './useGithubSignedIn';

/**
 * Renders a code-insights card only once GitHub credentials are held.
 *
 * Signed out, the card's own vendor wrapper would render a "Sign in to GitHub"
 * card of its own — four identical ones across a Repository overview. The
 * single `GithubSignInCard` asks instead; see that file for the rest.
 */
export function GithubSignInGate({ children }: { children: ReactNode }) {
  const { isSignedIn } = useGithubSignedIn();
  return isSignedIn ? <>{children}</> : null;
}
